import { render, staticRenderFns } from "./SvgSuperUser.vue?vue&type=template&id=72494e50&scoped=true&"
import script from "./SvgSuperUser.vue?vue&type=script&lang=js&"
export * from "./SvgSuperUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72494e50",
  null
  
)

export default component.exports